export const size = {
  'mobile': '768px',
  'mobileNum': 768
}